<template>
  <div class="pdp-purchase-options" role="group">
    <OneTimePurchaseOption />

    <RechargeSubscriptionPurchaseOption v-if="!shopifySubscriptionsEnabled" />

    <ShopifySubscriptionPurchaseOption v-if="shopifySubscriptionsEnabled" />
  </div>
</template>

<script>
import OneTimePurchaseOption from './OneTimePurchaseOption';
import RechargeSubscriptionPurchaseOption from './RechargeSubscriptionPurchaseOption';
import ShopifySubscriptionPurchaseOption from './ShopifySubscriptionPurchaseOption';

export default {
  name: 'PurchaseOptions',

  components: {
    OneTimePurchaseOption,
    RechargeSubscriptionPurchaseOption,
    ShopifySubscriptionPurchaseOption
  },

  computed: {
    shopifySubscriptionsEnabled: () => __SHOPIFY_SUBSCRIPTIONS__
  }
};
</script>
